import { CropAnatomy as o } from "./Crop.anatomy.es.js";
const e = {
  parts: o.keys,
  baseStyle: {
    container: {
      "& > img": {
        maxWidth: "100%"
      },
      "& .cropper-view-box": {
        outlineWidth: "1px",
        outlineStyle: "dashed",
        outlineColor: "primary.700"
      },
      "& .cropper-line": {
        backgroundColor: "transparent"
      },
      "& .cropper-point": {
        boxSize: 2,
        backgroundColor: "white"
      },
      img: {
        display: "block",
        maxWidth: "100%"
      }
    }
  }
};
export {
  e as Crop
};
//# sourceMappingURL=Crop.es.js.map
